import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    class: {
      dosagePopin: _vm.mode == "popin"
    }
  }, [_c("div", [_c(VForm, {
    staticClass: "dfwa-form",
    model: {
      value: _vm.form.valid,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "valid", $$v);
      },
      expression: "form.valid"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      label: "Dosage label",
      rules: [_vm.formRules.mustNotBeEmpty],
      "hide-details": "auto"
    },
    model: {
      value: _vm.baseModel.label,
      callback: function callback($$v) {
        _vm.$set(_vm.baseModel, "label", $$v);
      },
      expression: "baseModel.label"
    }
  })], 1), _vm.existingDosages.length > 0 ? _c("div", {
    staticClass: "flex flex-column justify-start items-start mt-default"
  }, [_c("div", {
    staticClass: "flex items-baseline justify-start gap-2"
  }, [_c(VIcon, {
    class: ["fa cursor--pointer", _vm.isShowExisitingDosages ? "fa-eye-slash" : "fa-eye"],
    attrs: {
      size: "16"
    },
    on: {
      click: function click($event) {
        return _vm.toggleShowDosages();
      }
    }
  }), _c("span", {
    staticClass: "text-bold cursor--pointer",
    on: {
      click: function click($event) {
        return _vm.toggleShowDosages();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.existingDosages.length) + " existing dosages ")])], 1), _vm.isShowExisitingDosages ? _c("ul", {
    staticClass: "rm-margin"
  }, _vm._l(_vm.existingDosages, function (item) {
    var _vm$manageExistingDos, _vm$manageExistingDos2, _vm$manageExistingDos3;
    return _c("li", {
      key: "existingDosage-".concat(item.id_dosage),
      staticClass: "text-smaller py-1"
    }, [_c("div", {
      staticClass: "flex items-center gap-4"
    }, [_c("div", [_vm._v(_vm._s("".concat(item.label)))]), _c("div", {
      staticClass: "flex items-center gap-2"
    }, [_c(VIcon, {
      staticClass: "cursor--pointer fa fa-edit",
      attrs: {
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.startEditDosage(item.id_dosage);
        }
      }
    }), _c(VIcon, {
      staticClass: "cursor--pointer fa fa-trash",
      attrs: {
        size: "12"
      },
      on: {
        click: function click($event) {
          return _vm.deleteDosage(item.id_dosage);
        }
      }
    })], 1)]), ((_vm$manageExistingDos = _vm.manageExistingDosage.error.delete) === null || _vm$manageExistingDos === void 0 ? void 0 : _vm$manageExistingDos.id_dosage) == item.id_dosage ? [_c("div", [((_vm$manageExistingDos2 = _vm.manageExistingDosage.error.delete) === null || _vm$manageExistingDos2 === void 0 ? void 0 : _vm$manageExistingDos2.code) === "wine_attached" ? [_c("div", {
      staticClass: "flex items-baseline justify-start gap-2"
    }, [_c(VIcon, {
      class: ["fa cursor--pointer", _vm.manageExistingDosage.error.delete.isDetailsShown ? "fa-eye-slash" : "fa-eye"],
      attrs: {
        size: "16"
      },
      on: {
        click: function click($event) {
          return _vm.toggleShowErrorDeleteDosageAttached();
        }
      }
    }), _c("span", {
      staticClass: "errorLabel cursor--pointer",
      on: {
        click: function click($event) {
          return _vm.toggleShowErrorDeleteDosageAttached();
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.manageExistingDosage.error.delete.data.length) + " wine(s) are attached to this dosage. It can't be deleted ")])], 1), _vm.manageExistingDosage.error.delete.isDetailsShown ? _c("ul", {
      staticClass: "rm-margin pl-5"
    }, _vm._l(_vm.manageExistingDosage.error.delete.data, function (wine) {
      return _c("li", {
        key: "existingDosage-".concat(item.id_dosage, "-error-appellation-attached-").concat(wine.id_wine),
        staticClass: "text-smaller"
      }, [_vm._v(" " + _vm._s("".concat(wine.accountancy_code, " : ").concat(_vm.formatWineNaming(wine.naming_data))) + " ")]);
    }), 0) : _vm._e()] : _vm._e()], 2)] : _vm._e(), ((_vm$manageExistingDos3 = _vm.manageExistingDosage.model) === null || _vm$manageExistingDos3 === void 0 ? void 0 : _vm$manageExistingDos3.id_dosage) === item.id_dosage ? _c("div", {
      staticClass: "mt-2 pb-5 px-5 mb-3",
      staticStyle: {
        "border-left": "1px #dadada solid",
        "border-bottom": "1px #dadada solid"
      }
    }, [_c(VForm, {
      staticClass: "dfwa-form",
      model: {
        value: _vm.manageExistingDosage.form.valid,
        callback: function callback($$v) {
          _vm.$set(_vm.manageExistingDosage.form, "valid", $$v);
        },
        expression: "manageExistingDosage.form.valid"
      }
    }, [_c(VTextField, {
      staticClass: "required",
      attrs: {
        label: "Classification label",
        rules: [_vm.formRules.mustNotBeEmpty],
        "hide-details": "auto"
      },
      model: {
        value: _vm.manageExistingDosage.model.label,
        callback: function callback($$v) {
          _vm.$set(_vm.manageExistingDosage.model, "label", $$v);
        },
        expression: "manageExistingDosage.model.label"
      }
    })], 1), _c("div", {
      staticClass: "flex items-center mt-small"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: true
      },
      on: {
        click: function click($event) {
          return _vm.closeEditExistingDosage();
        }
      }
    }, [_vm._v(" Cancel ")]), _c(VBtn, {
      staticClass: "dfwa-btn --small-2",
      attrs: {
        rounded: true,
        disabled: !_vm.manageExistingDosage.form.valid
      },
      on: {
        click: function click($event) {
          return _vm.saveEditExistingDosage();
        }
      }
    }, [_vm._v(" Save ")])], 1)], 1) : _vm._e()], 2);
  }), 0) : _vm._e(), _vm._m(0)]) : _vm._e(), _c("div", {
    staticClass: "bloc-buttons-popin"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Close")]), _c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.form.valid
    },
    on: {
      click: function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.isEdit ? "Save" : "Create") + " ")])], 1)], 1), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "tip mt-small-2"
  }, [_c("i", {
    staticClass: "fas fa-lightbulb pr-2"
  }), _vm._v(" Please be care to not create duplicate of existing dosage. ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };